import { Button } from '@mui/material'
import React from 'react'
import Modal from '../../Modal/Modal'
import classes from './AdminDeleteModal.module.css'

const AdminDeleteModal = (props) => {
    const { onClose, onRemove, deleteItem, item, name } = props

    const handleRemove = () => {
        deleteItem(item._id)
        onRemove(null)
    }

    return (
        <Modal title={`Видалити ${name}`} onClose={onClose}>
            <p className={classes.text}>Цю дію неможливо буде відмінити. Ви впевнені?</p>
            <div className={classes.footer}>
                <Button onClick={handleRemove} color="warning" className={classes.remove}>Видалити</Button>
                <Button onClick={onClose}>Відмінити</Button>
            </div>
        </Modal>
    )
}

export default AdminDeleteModal